module.exports = __webpack_public_path__ + "static/media/uprez_bar.002c010f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/uprez_bar.svg
// module id = 1038
// module chunks = 0